import { SetFilterValuesFuncParams } from "ag-grid-enterprise";
import { OrderTransport } from "src/app/transports/order";

export const allValuesAsync = {
    blog: {
        getManager: async (params: SetFilterValuesFuncParams) => {
            const filterModel = params.api.getFilterModel();
            const data = await OrderTransport.reviewed.blog.columnsValues({ filterModel });
            const manager = data.managerOptions?.split(",") || [];
            params.success(manager);
        },
        getMoneySite: async (params: SetFilterValuesFuncParams) => {
            const filterModel = params.api.getFilterModel();
            const data = await OrderTransport.reviewed.blog.columnsValues({ filterModel });
            const moneySite = data.moneySiteOptions?.split(",") || [];
            const platform = data.platformsOptions?.split(",") || [];
            params.success([...moneySite, ...platform]);
        },
        getRd: async (params: SetFilterValuesFuncParams) => {
            const filterModel = params.api.getFilterModel();
            const data = await OrderTransport?.reviewed.blog.columnsValues({ filterModel });
            const rd = data.rdOptions.split(",") || [];
            params.success(rd);
        },

        getWritingType: async (params: SetFilterValuesFuncParams) => {
            const filterModel = params.api.getFilterModel();
            const data = await OrderTransport?.reviewed.blog.columnsValues({ filterModel });
            const contentType = data.contentTypeOptions.split(",") || [];
            const writingType = data.writingTypeOptions.split(",") || [];
            const aux: string[] = [];

            contentType.forEach((el: string) =>
                writingType.forEach((el2: string) => aux.push(`${el} ${el2}`))
            );
            params.success(aux);
        },
    },
    lp: {
        getManager: async (params: SetFilterValuesFuncParams) => {
            const filterModel = params.api.getFilterModel();
            const data = await OrderTransport.reviewed.lp.columnsValues({ filterModel });
            const manager = data.managerOptions?.split(",") || [];
            params.success(manager);
        },
        getMoneySite: async (params: SetFilterValuesFuncParams) => {
            const filterModel = params.api.getFilterModel();
            const data = await OrderTransport.reviewed.lp.columnsValues({ filterModel });
            const moneySite = data.moneySiteOptions?.split(",") || [];
            const platform = data.platformsOptions?.split(",") || [];
            params.success([...moneySite, ...platform]);
        },
        getRd: async (params: SetFilterValuesFuncParams) => {
            const filterModel = params.api.getFilterModel();
            const data = await OrderTransport?.reviewed.lp.columnsValues({ filterModel });
            const rd = data.rdOptions.split(",") || [];
            params.success(rd);
        },

        getWritingType: async (params: SetFilterValuesFuncParams) => {
            const filterModel = params.api.getFilterModel();
            const data = await OrderTransport?.reviewed.lp.columnsValues({ filterModel });
            const contentType = data.contentTypeOptions.split(",") || [];
            const writingType = data.writingTypeOptions.split(",") || [];
            const aux: string[] = [];

            contentType.forEach((el: string) =>
                writingType.forEach((el2: string) => aux.push(`${el} ${el2}`))
            );
            params.success(aux);
        },
    },
};
